import UsMap from './_modules/UsMap';
import { CountUp } from 'countup.js';

export default function SectionMarketMap(el, {
    states,
}) {
    const usMap = new UsMap(document.getElementById('map'), states); // eslint-disable-line no-new
    usMap.activeCallback = () => {
        const stats = el.querySelectorAll('.active [data-stat]');
        stats.forEach(numNode => {
            const statNum = numNode.innerText;
            const statNumInt = parseInt(statNum.replace(',', ''), 10);
            const countUp = new CountUp(
                numNode,
                statNumInt,
                {
                    duration: 2,
                },
            );
            countUp.start();
        });
    };
}
